import React from 'react';
import PropTypes from 'prop-types';
import s from './MapNoteFilter.module.scss';

const MapNoteStatusFilter = props => (
    <div className={s.labelWrapper}>
        <label htmlFor={props.label} className={s.option}>
            <input type="radio" name={props.label} value={props.label} onChange={() => props.onClick()} checked={props.selected} id={props.label} />
            <div className={s.radio} />
            <div className={s.label}>{`${props.label} (${props.amount})`}</div>
        </label>
    </div>
);

MapNoteStatusFilter.propTypes = {
    selected: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default MapNoteStatusFilter;
